import { Button, Input, Switch, Table } from 'antd';
import React, { useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AddBankAccountModal from '../Modal/AddBankAccountModal';

const dataSource = [
  {
    key: '1',
    accountHolder: 'Bear King Brewing Company LLC (company)',
    bankName: 'WELLS FARGO BANK NA',
    accountNumber: 3265,
    ePayment: 'eligible',
    autoPay: 1
  }
];

const inventoryColumns = [
  {
    title: 'Account Holder',
    dataIndex: 'accountHolder',
    key: 'accountHolder',
  },
  {
    title: 'Bank Name',
    dataIndex: 'bankName',
    key: 'bankName',
  },
  {
    title: 'Account Number (Last 4)',
    dataIndex: 'accountNumber',
    key: 'accountNumber',
  },
  {
    title: 'Electronic Payment',
    dataIndex: 'ePayment',
    key: 'ePayment',
  },
  {
    title: 'Use for AutoPay',
    dataIndex: 'autoPay',
    key: 'autoPay',
    render: (value) => (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Switch
          size='small'
          checked={value === 1}
        // onClick={val => console.log(val)}
        />
      </div>
    )
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    render: (_, row) => (
      <div style={{ display: 'flex', gap: 10 }}>
        <Button className='printButton2'>Edit</Button>
        <Button danger type="primary">Delete</Button>
      </div>
    )
  },
];

function ManageBankAccounts({ setActiveTab }) {
  const [showBankAccountModal, setShowBankAccountModal] = useState(false);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            style={{ padding: 0, border: 'none', boxShadow: 'none' }}
            onClick={() => { setActiveTab(1) }}
          >
            <ChevronLeftIcon style={{ marginBottom: '5px' }} />
          </Button>
          <h5>Bank Accounts</h5>
        </div>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            className='printButton'
            onClick={() => { setShowBankAccountModal(true); }}
          >
            Add Bank Account
          </Button>
        </div>
      </div>
      <div className='topInventoryChangesTableOuter'>
        <Table
          dataSource={dataSource}
          columns={inventoryColumns}
          pagination={false}
        />
      </div>
      <div style={{ marginTop: 40 }}>
        <table style={{ width: '100%', border: '1px solid #ccc' }}>
          <thead>
            <tr style={{ border: '1px solid #ccc' }}>
              <th colSpan={2}>
                <div style={{ padding: 10 }}>Company Information (as you want to display on payments to vendors):</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ border: '1px solid #ccc' }}>
              <td style={{ width: '30%', padding: 5, border: '1px solid #ccc' }}>
                Company Name <span style={{ color: 'red' }}>*</span>
              </td>
              <td>
                <div style={{ padding: 5 }}>
                  <Input
                    style={{ width: '100%', }}
                  />
                </div>
              </td>
            </tr>
            <tr style={{ border: '1px solid #ccc' }}>
              <td style={{ width: '30%', padding: 5, border: '1px solid #ccc' }}>
                Address Line 1 <span style={{ color: 'red' }}>*</span>
              </td>
              <td>
                <div style={{ padding: 5 }}>
                  <Input
                    style={{ width: '100%', }}
                  />
                </div>
              </td>
            </tr>
            <tr style={{ border: '1px solid #ccc' }}>
              <td style={{ width: '30%', padding: 5, border: '1px solid #ccc' }}>Address Line 2</td>
              <td>
                <div style={{ padding: 5 }}>
                  <Input
                    style={{ width: '100%', }}
                  />
                </div>
              </td>
            </tr>
            <tr style={{ border: '1px solid #ccc' }}>
              <td style={{ width: '30%', padding: 5, border: '1px solid #ccc' }}>
                City <span style={{ color: 'red' }}>*</span>
              </td>
              <td>
                <div style={{ padding: 5 }}>
                  <Input
                    style={{ width: '100%', }}
                  />
                </div>
              </td>
            </tr>
            <tr style={{ border: '1px solid #ccc' }}>
              <td style={{ width: '30%', padding: 5, border: '1px solid #ccc' }}>
                State <span style={{ color: 'red' }}>*</span>
              </td>
              <td>
                <div style={{ padding: 5 }}>
                  <Input
                    style={{ width: '100%', }}
                  />
                </div>
              </td>
            </tr>
            <tr style={{ border: '1px solid #ccc' }}>
              <td style={{ width: '30%', padding: 5, border: '1px solid #ccc' }}>
                Zip Code <span style={{ color: 'red' }}>*</span>
              </td>
              <td>
                <div style={{ padding: 5 }}>
                  <Input
                    style={{ width: '100%', }}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: 10, display: 'flex', justifyContent: 'end' }}>
          <Button
            className='printButton'
          >
            Save
          </Button>
        </div>
      </div>
      <AddBankAccountModal
        visible={showBankAccountModal}
        setVisible={setShowBankAccountModal}
      />
    </div>
  )
}

export default ManageBankAccounts;
